module.exports = __webpack_public_path__ + "e900de1ede8b04b5568069bf3481ee7e.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/chunky-gem-earrings-s.png
// module id = 2784
// module chunks = 0